import {initTabSlider} from "../inits/_tab-slider.init.js";
import Collapse from "bootstrap/js/src/collapse.js";
import {
  initBackgroundGridAnimation,
  initFooterC2aAnimation,
  initStaggeredChildrenReveal, refreshAllScrollTriggers
} from "../inits/_animatons.init.js";

(() => {
  initStaggeredChildrenReveal();
  initTabSlider(Collapse);
})();

(() => {
  initBackgroundGridAnimation()
  initFooterC2aAnimation();
  refreshAllScrollTriggers();
})();

window.addEventListener('resize', () => {
  refreshAllScrollTriggers();
}, {passive: true});
